import { Component, OnInit } from '@angular/core';
import {LayoutService} from "../layout.service";
import { Router } from '@angular/router';
import { Sucursal, SucursalRol } from 'app/core/model/trjireh-model';

@Component({
  selector: 'sa-ribbon',
  templateUrl: './ribbon.component.html'
})
export class RibbonComponent implements OnInit {

  sucursal: Sucursal = new Sucursal();
  sucursales: SucursalRol[] = [];
  cargando = false;

  constructor(private layoutService: LayoutService,
    private router: Router) {}

  ngOnInit() {
    this.cargando = true;
    const sucursalRol = JSON.parse(localStorage.getItem('sucursalRol'));
    this.sucursales = JSON.parse(localStorage.getItem('sucursales'));
    if (sucursalRol) {
      this.sucursal = sucursalRol.sucursal;
    }
    this.cargando = false;
  }

  resetWidgets() {
    this.layoutService.factoryReset()
  }

  CambiaSucursal(idSucursal: number) {

    if (this.sucursales && this.sucursales.length > 0) {
      const sucursal = this.sucursales.filter(s => s.sucursal.idSucursal == idSucursal);

      if (sucursal && sucursal.length > 0) {
        localStorage.setItem('sucursalRol', JSON.stringify(sucursal[0]));
        //this.projectsService.redirectTo();
        this.router.navigate(['/home']);
        //this.location.go(this.router.url);
        //console.log('Cambiada:', sucursal[0]);
        //this.router.navigate(['/auth/login']);
      }

    }
  }

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/ribbon/ribbon.component.ts